import React from "react";
import { Provider } from "react-redux";
import { ConnectedRouter } from "react-router-redux";
import { Helmet } from "react-helmet";
/**
 * You can remove bootstrap here and also from package.json
 */
import "bootstrap/dist/css/bootstrap.css";
import "./App.css";

import Layout from "./Layout";
import Error from "./Error";
import Info from "./Info";
import TimeoutWarning from "./TimeoutWarning";
import BurgerButton from "./BurgerButton";
import Routes from "../../routes";
import Sidebar from "./Sidebar/Sidebar";

const matchMediaFullScreen = window.matchMedia(`(min-width: 768px)`);

/**
 * Wrapper of entire application
 *
 * @param history
 * @param store
 * @returns {*}
 */
export default class App extends React.Component {
  state = {
    matchMediaFullScreen: matchMediaFullScreen,
    sidebarDocked: false,
    sidebarOpen: false
  };

  onSetSidebarOpen(open) {
    this.setState({ sidebarOpen: open });
  }

  componentWillMount() {
    matchMediaFullScreen.addListener(this.mediaQueryChanged.bind(this));
    this.setState({
      matchMediaFullScreen: matchMediaFullScreen,
      sidebarDocked: matchMediaFullScreen.matches
    });
  }

  componentWillUnmount() {
    this.state.matchMediaFullScreen.removeListener(this.mediaQueryChanged);
  }

  mediaQueryChanged() {
    this.setState({ sidebarDocked: this.state.matchMediaFullScreen.matches });
  }

  toggleSidebar() {
    this.setState({ sidebarOpen: !this.state.sidebarOpen });
  }

  render() {
    return (
      <Provider store={this.props.store}>
        <ConnectedRouter history={this.props.history}>
          <Layout
            docked={this.state.sidebarDocked}
            onSetOpen={this.onSetSidebarOpen.bind(this)}
            open={this.state.sidebarOpen}
            sidebar={Sidebar}
          >
            <Helmet defaultTitle="Fischer Homes" />

            <div className="App container-fluid">
              <BurgerButton onClick={this.toggleSidebar.bind(this)} />

              <Routes />

              <div className="Notifications">
                <Error />
                <Info />
                <TimeoutWarning />
              </div>
            </div>
          </Layout>
        </ConnectedRouter>
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/App/App.js